exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cap-csv-file-uploader{display:inline-block}.cap-csv-file-uploader .file-upload{position:relative;overflow:hidden;margin:0 10px}.cap-csv-file-uploader .file-upload input.upload{position:absolute;top:0;right:0;margin:0;padding:0;font-size:20px;cursor:pointer;opacity:0;filter:alpha(opacity=0)}.cap-csv-file-uploader .buttonFileUpload{padding:4px 24px;font-weight:600;border:1px solid;color:#2466ea;border-radius:6px}.cap-csv-file-uploader .btn{display:inline-block;text-align:center;cursor:pointer}.cap-csv-file-uploader a{color:#2466ea}\n", ""]);

// exports
